import { useMutation } from "@tanstack/react-query";

import type {
    CrmEnrichmentJob,
    CrmEnrichmentJobDTO,
} from "app/pages/sales-intelligence/modules/crm-enrichment/types/types";
import { quotaQueryClient } from "app/pages/sales-intelligence/modules/quota/queries/client";

import { useHsEnrichmentJobCache } from "../hooks/useHsEnrichmentJobCache";
import hubspotEnrichmentAPIService from "../services/api/hubspotEnrichmentAPIService";

export default function useHsEnrichmentJobCreateMutation() {
    const { addNewJobToCache } = useHsEnrichmentJobCache();

    return useMutation<CrmEnrichmentJob, unknown, CrmEnrichmentJobDTO>({
        mutationFn(dto) {
            return hubspotEnrichmentAPIService.createJob(dto);
        },
        onSuccess(data) {
            addNewJobToCache(data);
            void quotaQueryClient.invalidateDataCreditsState();
        },
    });
}
